import type { CurrentUser } from '../../types/user';
import { formatUserDisplayName } from '../../lib/formatUserDisplayName';

// P2b-3 round-1 polish Fix 6: per-row builder dropdown shared between
// the Meta and Google grids. Same pattern as MasterGrid's AM cell —
// native <select>, inline patch on change. "— Unassigned —" sentinel
// for the null option.

type Props = {
  value: string | null;
  users: CurrentUser[];
  disabled?: boolean;
  ariaLabel: string;
  onChange: (next: string | null) => void;
};

export function BuilderCell({ value, users, disabled, ariaLabel, onChange }: Props) {
  return (
    <select
      value={value ?? ''}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value || null)}
      aria-label={ariaLabel}
      className="rounded border border-slate-200 px-1 py-0.5 text-xs max-w-[140px] disabled:opacity-50"
    >
      <option value="">— Unassigned —</option>
      {users.map((u) => (
        <option key={u.uid} value={u.uid}>
          {formatUserDisplayName(u)}
        </option>
      ))}
    </select>
  );
}
